import { render, staticRenderFns } from "./index.vue?vue&type=template&id=083e17cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e17cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083e17cc')) {
      api.createRecord('083e17cc', component.options)
    } else {
      api.reload('083e17cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=083e17cc&scoped=true", function () {
      api.rerender('083e17cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/postManage/index.vue"
export default component.exports